import { EnvironmentFilled, ArrowDownOutlined, CheckCircleFilled } from "@ant-design/icons";
import { TruckingGuestRoutePointDto } from "../dtos/ShipmentTruckingGuestInfoResponseDto";

interface Props {
  routePoints?: TruckingGuestRoutePointDto[];
  currentRoutePoint?: TruckingGuestRoutePointDto | null;
  accentColor: string;
}

export const RouteOverview = ({ routePoints = [], currentRoutePoint, accentColor }: Props) => {
  if (!routePoints.length) return null;
  return (
    <div className="bg-white p-3 rounded-2xl shadow-sm border">
      <div className="text-[11px] font-black uppercase text-gray-500 mb-2 tracking-wider">LỘ TRÌNH</div>

      <div className="flex flex-col gap-2">
        {routePoints.map((point, index) => {
          const isCurrent = point.id === currentRoutePoint?.id;
          const isDone = point.stopOrder! < (currentRoutePoint?.stopOrder ?? 0);

          return (
            <div key={point.id} className="flex items-start gap-2">
              {/* Dot */}
              <div className="flex flex-col items-center">
                <div
                  className={`w-6 h-6 flex items-center justify-center rounded-full text-[10px] font-black
                  ${isDone ? "text-white" : isCurrent ? "text-white" : "bg-gray-200 text-gray-400"}`}
                  style={{
                    background: isDone ? accentColor + "cc" : isCurrent ? accentColor : undefined,
                  }}
                >
                  {isDone ? "✓" : point.stopOrder}
                </div>

                {index < routePoints.length - 1 && <ArrowDownOutlined className="text-gray-300 text-[10px] my-1" />}
              </div>

              {/* Content */}
              <div className="flex-1">
                <div className="flex items-center gap-1">
                  <span className={`text-[10px] font-bold uppercase ${isCurrent ? "text-blue-600" : "text-gray-400"}`}>{point.stopTypeName}</span>

                  {isCurrent && (
                    <span className="text-[9px] px-1.5 py-0.5 rounded bg-blue-100 text-blue-600 font-bold">
                      {point.status === 1 || point.status === 2 ? "ĐÃ ĐẾN" : "ĐANG ĐẾN"}
                    </span>
                  )}

                  {isDone && <CheckCircleFilled className="text-green-500 text-[10px]" />}
                </div>

                <div className="flex items-start gap-1 text-xs text-gray-700 font-semibold">
                  <EnvironmentFilled className="text-gray-400 mt-0.5" />
                  <span className="break-words">{point.checkInAddress}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
